import $axios from "./service.util";
// 示例代码
const post = (data) => {
    return $axios({
        url: '/post/post',
        method: 'post',
        data: data
    })
}

const get = (data) => {
    return $axios({
        url: '/get/get' + data,
        method: 'get'
    })
}

const login = (data) => {
    return $axios({
        url: '/user/login',
        method: 'post',
        data: data
    })
}

const list = (data) => {
    return $axios({
        url: '/exportInfoHistory/list',
        method: 'post',
        data: data
    })
}

const update = (data) => {
    return $axios({
        url: '/exportInfoHistory/update',
        method: 'post',
        data: data
    })
}

const outExcel = (data) => {
    return $axios({
        url: '/exportInfoHistory/numberForOutExcel' + data,
        method: 'get'
    })
}

const banner = (id) => {
    return $axios({
        url: `/basic/banner/list?parentId=${id}`,
        method: 'get'
    })
}
const intelligence = (data) => {
    return $axios({
        url: '/basic/intelligence/list',
        method: 'get'
    })
}
const helpPage = (data) => {
  return $axios({
    url: '/basic/help/page',
    method: 'post',
    data: data
  })
}
const guidePage = (id) => {
  return $axios({
    url: `/basic/guide/list?parentId=${id}`,
    method: 'get'
  })
}

const informationInfo = (id) => {
  return $axios({
    url: `/basic/information/${id}`,
    method: 'get'
  })
}
const information = (data) => {
  return $axios({
    url: '/basic/information/page',
    method: 'post',
    data: data
  })
}
const hospitalList = (data) => {
  return $axios({
    url: '/hospital/model/list',
    method: 'post',
    data: data
  })
}
const hospitalListPage = (data) => {
  return $axios({
    url: '/hospital/model/page',
    method: 'post',
    data: data
  })
}
const category = (data) => {
  return $axios({
    url: `/basic/guide/category`,
    method: 'get'
  })
}
const professional = (data) => {
  return $axios({
    url: `/hospital/model/professional/list`,
    method: 'post',
    data: data
  })
}

const area = (data) => {
  return $axios({
    url: `/hospital/area/list`,
    method: 'get'
  })
}
const department = (data) => {
  return $axios({
    url: `/hospital/department/list`,
    method: 'get'
  })
}

const president = (data) => {
  return $axios({
    url: `/hospital/president/list`,
    method: 'get'
  })
}
const level = (data) => {
  return $axios({
    url: `/hospital/level/list`,
    method: 'get'
  })
}

const hospitalInfo = (id) => {
  return $axios({
    url: `/hospital/model/${id}`,
    method: 'get'
  })
}
const expertInfo = (id) => {
  return $axios({
    url: `/hospital/expert/${id}`,
    method: 'get'
  })
}

const getWebName = (id) => {
  return $axios({
    url: `/basic/config/getWebName`,
    method: 'get'
  })
}

const informationTj = (id) => {
  return $axios({
    url: `/basic/information/list?recommend=${id}`,
    method: 'get'
  })
}

const informationTj2 = (id) => {
  return $axios({
    url: `/basic/information/list?parentId=${id}`,
    method: 'get'
  })
}

const guideInfo = (id) => {
  return $axios({
    url: `/basic/guide/${id}`,
    method: 'get'
  })
}
const getTel = (id) => {
  return $axios({
    url: `/basic/config/getTel`,
    method: 'get'
  })
}

const getMiniLogo = (id) => {
  return $axios({
    url: `/basic/config/getMiniLogo`,
    method: 'get'
  })
}

const getVipRecords = (id) => {
  return $axios({
    url: `/basic/config/getVipRecords`,
    method: 'get'
  })
}
const getAppQrCode = (id) => {
  return $axios({
    url: `/basic/config/getAppQrCode`,
    method: 'get'
  })
}
const getWeChatQrCode = (id) => {
  return $axios({
    url: `/basic/config/getWeChatQrCode`,
    method: 'get'
  })
}

const getServiceQrCode = (id) => {
  return $axios({
    url: `/basic/config/getServiceQrCode`,
    method: 'get'
  })
}

const getIcpRecords = (id) => {
  return $axios({
    url: `/basic/config/getIcpRecords`,
    method: 'get'
  })
}
const partnerList = (id) => {
  return $axios({
    url: `/basic/partnerList`,
    method: 'get'
  })
}

const recordList = (id) => {
  return $axios({
    url: `/basic/recordList`,
    method: 'get'
  })
}

const descriptions = (id) => {
  return $axios({
    url: `/basic/descriptions`,
    method: 'get'
  })
}
const getAPPointmentQrCode = (id) => {
  return $axios({
    url: `/basic/config/getAPPointmentQrCode`,
    method: 'get'
  })
}

const getCompanyName = (id) => {
  return $axios({
    url: `/basic/config/getCompanyName`,
    method: 'get'
  })
}

const helpList = (id) => {
  return $axios({
    url: `/basic/helpList`,
    method: 'get'
  })
}
const guide = (data) => {
  return $axios({
    url: `/basic/guide/page`,
    method: 'post',
    data: data
  })
}
const expert = (data) => {
  return $axios({
    url: `/hospital/expert/page`,
    method: 'post',
    data: data
  })
}
const homeExpert = (data) => {
  return $axios({
    url: `/hospital/expert/list`,
    method: 'post',
    data: data
  })
}
const fastOrder = (data) => {
  return $axios({
    url: `/appointment/fastOrder`,
    method: 'post',
    data: data
  })
}
const order = (data) => {
  return $axios({
    url: `/appointment/order`,
    method: 'post',
    data: data
  })
}

export default {
    post,
    get,
    login,
    list,
  banner,
  descriptions,
  helpList,
  recordList,
  intelligence,
  partnerList,
  getAppQrCode,
  getWeChatQrCode,
  getServiceQrCode,
  helpPage,
  getCompanyName,
  guidePage,
  information,
  category,
  guide,
  area,
  department,
  hospitalList,
  hospitalListPage,
  president,
  level,
  expert,
  homeExpert,
  fastOrder,
  hospitalInfo,
  expertInfo,
  order,
  informationTj,
  informationTj2,
  guideInfo,
  professional,
  informationInfo,
  getWebName,
  getTel,
  getMiniLogo,
  getIcpRecords,
  getVipRecords,
  getAPPointmentQrCode,
    update,
    outExcel
}
